import type { ReactNode } from "react";

interface FilterBarProps {
  subOptions: string[];
  sub: string;
  region: string;
  year: string;
  sort: string;
  onSub: (value: string) => void;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
  onSort: (value: string) => void;
}

const regions = ["全部", "中国", "韩国", "日本", "欧美"];
const years = ["全部", "近一年", "近三年", "经典"];
const sorts = ["最新", "热门", "评分"];

function Pill({
  active,
  children,
  onClick,
}: {
  active: boolean;
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-background-200"
      }`}
    >
      {children}
    </button>
  );
}

export default function FilterBar({
  subOptions,
  sub,
  region,
  year,
  sort,
  onSub,
  onRegion,
  onYear,
  onSort,
}: FilterBarProps) {
  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-2">
        {["全部", ...subOptions].map((item) => (
          <Pill key={item} active={sub === item} onClick={() => onSub(item)}>
            {item}
          </Pill>
        ))}
      </div>

      <div className="space-y-3 rounded-lg border border-background-200 bg-white p-4">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <span className="w-12 shrink-0 text-sm font-medium text-foreground-700">地区</span>
          <div className="flex flex-wrap gap-2">
            {regions.map((item) => (
              <Pill key={item} active={region === item} onClick={() => onRegion(item)}>
                {item}
              </Pill>
            ))}
          </div>
        </div>
        <div className="h-px bg-background-100"></div>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <span className="w-12 shrink-0 text-sm font-medium text-foreground-700">年份</span>
          <div className="flex flex-wrap gap-2">
            {years.map((item) => (
              <Pill key={item} active={year === item} onClick={() => onYear(item)}>
                {item}
              </Pill>
            ))}
          </div>
        </div>
        <div className="h-px bg-background-100"></div>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <span className="w-12 shrink-0 text-sm font-medium text-foreground-700">排序</span>
          <div className="flex flex-wrap gap-2">
            {sorts.map((item) => (
              <Pill key={item} active={sort === item} onClick={() => onSort(item)}>
                {item}
              </Pill>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}